import React from "react";

const NotificationDropdown = () => (
  <li className="nav-item dropdown">
    <a className="nav-link" id="navbarDropdownNotification" href="#!" role="button" data-bs-toggle="dropdown">
      <span className="d-inline-block" style={{ height: "12px", width: "12px" }}>
        <span data-feather="bell" />
      </span>
    </a>
  </li>
);

export default NotificationDropdown;
